import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.development";
import { constantvalues } from "../../const";
import { DtoClientAccount, ClientAccountDetails, DtoClientAdmin, UserRoles } from "../../models/mat-account.model";
import { map } from "rxjs";
@Injectable({
    providedIn: 'root'
})

export class MatAccountService{
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl; 
    }

    getAccountAdminDetails(userRole: string[]){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.GET_ACCOUNT_ADMIN_LIST}`, userRole);
    }

    createMatAccount(matAccountDetails: DtoClientAccount){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ACCOUNT}`, matAccountDetails);
    }

    validateMatAccount(matAccountDetails: DtoClientAccount): Promise<any>{
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.VALIDATE_MAT_ACCOUNT}`, matAccountDetails).pipe(
            map(response => response) // Adjust mapping as needed
          ).toPromise();;
    }

    getMatAccount(sectorId:number, payload: any){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.GET_MAT_ACCOUNT}/${sectorId}`, {params: payload});
    }

    swapPackage(matAccountDetail: ClientAccountDetails){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.SWAP_PACKAGE}`, matAccountDetail);
    }

    getMatAdminDetails(email: string, clientAccountId: number){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ADMIN}/${email}/${clientAccountId}`);
    }

    getMatAdminInformation(payload: any, matAccountId: number){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.ADMIN_DETAILS}/${matAccountId}`, {params: payload});
    }

    editMatAccount(matAccountDetails: DtoClientAccount){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ACCOUNT}`, matAccountDetails);
    }

    deleteMatAccount(clientAccountId: number){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ACCOUNT}`, {
            params: {
                clientAccountId: clientAccountId
            }
        });
    }

    deleteMatAdmin(clientAdminId: number){
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.DELETE_MAT_ADMIN}`, {
            params: {
                clientAdminId: clientAdminId
            }
        });
    }

    getAdminDetails(matAccountId: number){
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ACCOUNT}/${matAccountId}`);
    }

    editMatAdmin(matAdmin: DtoClientAdmin){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ADMIN}`, matAdmin);
    }

    createMatAdmin(matAdmin: DtoClientAdmin[], clientAccountId: number){
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ADMIN}/${clientAccountId}`, matAdmin);
    }

    uploadDocument(myFiles: FormData, documentTypeId: string, matAccountId: string) {
        return this.httpClient.post(`${this.baseURL}${constantvalues.API_URL.UPLOAD_DOCUMENT}/${documentTypeId}/${matAccountId}`, myFiles)
          .pipe(map(res => {
            return res;
          }));
    }

    removeUploadedDocument(documentId: string) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.REMOVE_UPLOAD_DOCUMENT}/${documentId}`)
          .pipe(map(res => {
            return res;
          }));
    }

    updateMatAccountStatus(clientAccountId: number){
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_MAT_ACCOUNT}/${clientAccountId}`, null);
    }

    allowCreateSchoolUser(schoolId: number): Promise<any>{
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.ALLOW_CREATE_SCHOOL_USER}/${schoolId}`).pipe(
            map((response) => response)
          ).toPromise();
    }
}